/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Guid as _guid } from './guid';

export namespace Random {
    export import Guid = _guid;
}
